// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c9abf334","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/pages/bookings/bookings.vue
// module id = 773
// module chunks = 1